import {
    gridGutterHalf,
    fontSize24
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from "../../../../../../js/shared/new-theme";

export const defaultStyle = `
    display: flex;
    flex-direction: column;
    flex: 1;
    
    p {
        margin: 0;
    }

    .expected {
        &--tooltip {
            display: flex;

            > div {
                margin-left: ${gridGutterHalf}px;
            }
        }

        &--price {
            font-weight: bold;
            color: ${theme.palette.gray[800].value};

            strong {
                font-size: ${fontSize24};    
            }
        }
    }
`;
